import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePipelineQuery } from '../apis';
import queryKeys from '../constants/queryKeys';

// PATCH /api/pipelines/{id} — partial UpdatePipelineDto (RV-4). No auto-toast on error:
// the Edit dialog (AC-19) must surface the 400 (1:1 conflict/validation, RV-3) INLINE
// without closing the dialog and without losing any entered field value.
//
// AC-17 — also invalidates the by-id detail cache (`getDetail`), not just the list, so the
// detail page's `useGetDetailPipeline(id)` (which the list never reads) reflects the saved
// values immediately too.
const useUpdatePipeline = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: updatePipelineQuery,
		onSuccess: (_data, variables) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.getList() });
			queryClient.invalidateQueries({ queryKey: queryKeys.getDetail(variables?.id) });
			// M3 (code review): this PATCH is how "save as default" writes `DefaultBranchName`
			// (AC-21/OQ-A), so the build-source read that derives `EffectiveBranchName` and
			// `IsPipelineOwnedDefault` is stale the moment it succeeds. Invalidated unconditionally —
			// a PATCH of any other field leaves the build-source response unchanged, so the extra
			// refetch is cheap and the alternative (inspecting `variables` for the field) is a
			// correctness trap the next field added would silently break.
			queryClient.invalidateQueries({ queryKey: queryKeys.getBuildSource(variables?.id) });
		}
	});
};

export default useUpdatePipeline;
